/**
 * SKU表单管理Hook
 * 职责: 管理新建/编辑表单的显示、状态切换
 * 限制: <50行
 */

import { useState, useCallback } from 'react';
import type { SKU } from '../../../types';

export const useSKUForm = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [brandMode, setBrandMode] = useState<'select' | 'custom'>('select');
  const [editingSKU, setEditingSKU] = useState<SKU | null>(null);

  /**
   * 打开新建对话框
   */
  const handleCreate = useCallback(() => {
    setEditingSKU(null);
    setModalVisible(true);
  }, []);

  /**
   * 打开编辑对话框
   */
  const handleEdit = useCallback((sku: SKU) => {
    setEditingSKU(sku);
    setModalVisible(true);
  }, []);

  return {
    modalVisible,
    brandMode,
    editingSKU,
    setBrandMode,
    setModalVisible,
    setEditingSKU,
    handleCreate,
    handleEdit,
  };
};

